module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "part-number-with-part-title",
    attrs: {
      "id": "_idParaDest-2",
      "lang": "en-US"
    }
  }, [_vm._v("Echoes")]), _vm._v(" "), _c('p', {
    staticClass: "part-title-with-part-number",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("(Eleven Years Later)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7966f45c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504082006-1.vue
// module id = 78
// module chunks = 0